export default __webpack_public_path__ + "static/media/news.835cb152.jpg";